<div class="background"
     [class.authenticated]="sessionService.isAuthenticated() && sessionService.isInitialized()"
     [class.public]="!sessionService.isAuthenticated()"></div>
<div class="loaderContainer loader"
     *ngIf="sessionService.LoaderInitStatus()"></div>
<ui-view name="base"></ui-view>
<ng-template ngbModalContainer></ng-template>
<ngx-loading-bar ref="router" [color]="'var(--edl-color-red)'" [includeSpinner]="false" [fixed]="true" [height]="'2px'"></ngx-loading-bar>
<build-version></build-version>
